'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$32() {
  this.bh9 = null;
  this.bh7 = null;
  this.bh8 = false;
  this.bh5 = null;
  this.bh6 = false;
  this.bha = false;
  this.bhb = false;
  this.bh9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$32 as $c_Lpresto_PrestoRouter$$anon$32 };
$p = $c_Lpresto_PrestoRouter$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$32;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$32() {
}
export { $h_Lpresto_PrestoRouter$$anon$32 as $h_Lpresto_PrestoRouter$$anon$32 };
$h_Lpresto_PrestoRouter$$anon$32.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bh9;
});
$p.t = (function() {
  if ((!this.bh8)) {
    this.bh7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh8 = true;
  }
  return this.bh7;
});
$p.ae = (function() {
  if ((!this.bh6)) {
    this.bh5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh6 = true;
  }
  return this.bh5;
});
$p.w = (function() {
  if ((!this.bhb)) {
    this.bha = false;
    this.bhb = true;
  }
  return this.bha;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$32, "presto.PrestoRouter$$anon$32", ({
  NY: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$32 as $d_Lpresto_PrestoRouter$$anon$32 };
//# sourceMappingURL=presto.-Presto-Router$$anon$32.js.map
